import {
  updatePlatformEndpointLocalNameRequestSchema,
  updatePlatformEndpointLocalNameResponseSchema,
  type UpdatePlatformEndpointLocalNameResponse,
} from "@multi-chat/shared";
import { apiPatch } from "./client.js";

/** Writes only the customer-editable channel name. Provider fields stay untouched. */
export async function updatePlatformEndpointLocalName(
  organizationId: number,
  platformEndpointId: number,
  localName: string,
  signal?: AbortSignal,
): Promise<UpdatePlatformEndpointLocalNameResponse> {
  const body = updatePlatformEndpointLocalNameRequestSchema.parse({ localName });
  return updatePlatformEndpointLocalNameResponseSchema.parse(
    await apiPatch(
      `/organizations/${organizationId}/platform-endpoints/${platformEndpointId}`,
      body,
      signal,
    ),
  );
}
